import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type Parameter = {
    parentProductId: string;
};

type HandlerType = Handler<Parameter>;
const DispatchRestoreClipboard: HandlerType = props => {      
    props.dispatch({
        type: "Widgets/Clipboard/RestoreFromStorage",
        parameter: { 
            parentProductId: props.parameter.parentProductId 
        }
    });
}


const chain = [DispatchRestoreClipboard];

const restoreClipboard = createHandlerChainRunner(chain, "RestoreClipboard");
export default restoreClipboard;